import { render, staticRenderFns } from "./debtor_details.vue?vue&type=template&id=b24cd8b4"
import script from "./debtor_details.vue?vue&type=script&lang=js"
export * from "./debtor_details.vue?vue&type=script&lang=js"
import style0 from "./debtor_details.vue?vue&type=style&index=0&id=b24cd8b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports